import React from 'react';

const PerformanceOptimizer = () => {
  React.useEffect(() => {
    // Enhanced lazy loading for all images
    const images = document.querySelectorAll('img');
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
          }
          // Add loading and decoding attributes for better performance
          if (!img.loading) img.loading = 'lazy';
          if (!img.decoding) img.decoding = 'async';
          imageObserver.unobserve(img);
        }
      });
    }, { threshold: 0.1 });
    
    images.forEach(img => imageObserver.observe(img));

    // Preload critical resources and optimize Core Web Vitals
    const optimizeCoreWebVitals = () => {
      // Preload critical fonts with font-display: swap
      const fontLink = document.createElement('link');
      fontLink.rel = 'preload';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
      fontLink.as = 'style';
      fontLink.crossOrigin = 'anonymous';
      document.head.appendChild(fontLink);

      // Critical CSS for LCP optimization
      const criticalCSS = document.createElement('style');
      criticalCSS.textContent = `
        /* Critical CSS for LCP optimization */
        .brand-display { font-size: clamp(2rem, 4vw, 3rem); line-height: 1.2; font-weight: 700; }
        .btn-primary, .btn-secondary { display: inline-flex; align-items: center; justify-content: center; }
        .hero-section { min-height: 100vh; display: flex; align-items: center; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 1rem; }
        /* Prevent layout shift */
        img { max-width: 100%; height: auto; }
        .service-card { min-height: 400px; }
      `;
      document.head.appendChild(criticalCSS);

      // Prefetch critical pages on interaction
      const setupPrefetch = () => {
        const criticalLinks = document.querySelectorAll('a[href^="/attorney-service"], a[href^="/place-order"], a[href^="/process-serving"]');
        criticalLinks.forEach(link => {
          link.addEventListener('mouseenter', () => {
            const prefetchLink = document.createElement('link');
            prefetchLink.rel = 'prefetch';
            prefetchLink.href = link.href;
            document.head.appendChild(prefetchLink);
          }, { once: true });
        });
      };

      setTimeout(setupPrefetch, 1000);
    };

    optimizeCoreWebVitals();

    // Resource hints for external domains
    const addResourceHints = () => {
      const hints = [
        { rel: 'dns-prefetch', href: '//fonts.googleapis.com' },
        { rel: 'dns-prefetch', href: '//fonts.gstatic.com' },
        { rel: 'preconnect', href: 'https://fonts.googleapis.com', crossorigin: true },
        { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: true }
      ];

      hints.forEach(hint => {
        const link = document.createElement('link');
        link.rel = hint.rel;
        link.href = hint.href;
        if (hint.crossorigin) link.crossOrigin = hint.crossorigin;
        document.head.appendChild(link);
      });
    };

    addResourceHints();

    return () => {
      images.forEach(img => imageObserver.unobserve(img));
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default PerformanceOptimizer;